export const ADS_DOMAIN = 'https://ads.tiktok.com';

const NOT_LOGGED_IN_ERR_CODE = 40304;

export const IGNORE_ERROR_CODE_LIST = [NOT_LOGGED_IN_ERR_CODE];

export enum Category {
  COMMERCE = 1,
  CREATIVE,
  BUSINESS_ACCOUNT_MANAGEMENT,
  BUSINESS_CENTER_MANAGEMENT,
  CATALOG_MANAGEMENT,
  CAMPAIGN_MANAGEMENT,
  REPORTING,
  LEAD_GEN,
  AUDIENCE,
  EVENTS,
  PROFESSIONAL_SERVICE,
}

export type CategoryStrType = keyof typeof Category;

export const CategoryArray = Object.keys(Category).filter((key) =>
  isNaN(Number(key))
) as CategoryStrType[];

// General Links
export const SITE_PATH = process.env.PROJECT_PREFIX || '';
export const SITE_BASE_PATH = `${ADS_DOMAIN}${SITE_PATH}`;
export const APP_CENTER_SEGMENT = '/app-center';
export const APP_CENTER_PATH = `${SITE_PATH}${APP_CENTER_SEGMENT}`;
export const APP_CENTER_BASE_PATH = `${SITE_BASE_PATH}${APP_CENTER_SEGMENT}`;
export const BASE_PATH = SITE_BASE_PATH;
export const LOGIN_PAGE = `${ADS_DOMAIN}/i18n/login`;

// Footer Links
export const TERMS_AND_POLICIES_PAGE = `https://ads.tiktok.com/i18n/official/policy/terms`;
export const PRIVACY_PAGE = `https://ads.tiktok.com/i18n/official/policy/privacy?`;
export const BECOME_A_DEV_PAGE = `https://form.typeform.com/to/mkpGOrfe?utm_source=app_center_footer`;
export const ABOUT_TIK_TOK_PAGE = `https://www.tiktok.com/about`;
export const TIK_TOK_PAGE = `https://www.tiktok.com/`;
export const BYTEDANCE_PAGE = `https://www.bytedance.com/`;
export const TIK_TOK_CAREERS_PAGE = `https://careers.tiktok.com/`;
export const SAFETY_PAGE = `https://www.tiktok.com/safety/en/`;
export const ADS_MANAGER = 'https://ads.tiktok.com/i18n/home';
export const CREATOR_MARKETPLACE = 'https://creatormarketplace.tiktok.com/home';
export const CREATIVE_EXCHANGE = 'https://ads.tiktok.com/creativeexchange/';
export const CREATIVE_CENTER = 'https://ads.tiktok.com/business/creativecenter/';
export const MARKETING_PARTNERS = 'https://partners.tiktok.com/';
export const HELP_CENTER_PAGE =
  'https://ads.tiktok.com/athena/requester/boards?identify_key=b25033ef7782d41050cbac74f751d547e9d8ad35a39a541a0f0efbbd51fe722f';
export const CONTACT_US_PAGE = 'https://www.tiktok.com/business/en/contact';
export const TIK_TOK_FOR_GOOD = 'https://www.tiktok.com/forgood';
export const TIK_TOK_FOR_DEVELOPERS = 'https://developers.tiktok.com/';
export const TIK_TOK_SHOP = 'https://shop.tiktok.com/business/';
export const BUSINESS_CENTER_PAGE = 'https://business.tiktok.com/';
export const ADVERTISING_SOLUTIONS = 'https://www.tiktok.com/business/en/solutions/ads';
export const CREATIVE_SOLUTIONS = 'https://www.tiktok.com/business/en/solutions/creative';
export const COMMERCE_SOLUTIONS = 'https://www.tiktok.com/business/en/solutions/ecommerce';
export const MEASUREMENT_SOLUTIONS = 'https://www.tiktok.com/business/en/solutions/measurement';

// Socials Links
export const TIKTOK_LINK = `https://www.tiktok.com/@tiktokforbusiness?lang=en`;
export const FACEBOOK_LINK = `https://www.facebook.com/TikTokforBusiness/`;
export const INSTAGRAM_LINK = `https://www.instagram.com/tiktok.forbusiness/`;
export const TWITTER_LINK = `https://www.twitter.com/TikTokBusiness`;
export const LINKEDIN_LINK = `https://www.linkedin.com/company/tiktokbusiness/`;

export const INSTALL_FLAG = 'install';

export const I18N_COOKIE_KEY = 'lang_type';
export const DEFAULT_LANG = 'en';
export const SUPPORTED_LANG_SET = new Set([
  'en',
  'ar',
  'de',
  'es',
  'fr',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'pt-BR',
  'ru',
  'th',
  'tr',
  'vi',
  'zh',
] as const);
export type SupportedLang = typeof SUPPORTED_LANG_SET extends Set<infer T> ? T : never;

export const TT_REQUESTS_REGEX = /https:\/\/\w+\.tiktok\.com\/.+/;

export type SearchParamsPageProps = { [key: string]: string | string[] | undefined };

export const AUTH_STATE_REDIRECT_KEY_PREFIX = 'AC-';

export const AUTH_TYPE_PARAM_KEY = 'auth_type';

export const APP_NAME_SEARCH_KEY = 'q';
export const CATEGORY_SEARCH_KEY = 'category_id';
export const CATEGORY_SEARCH_KEY_DELIMITER = '.';
if (CATEGORY_SEARCH_KEY_DELIMITER !== encodeURIComponent(CATEGORY_SEARCH_KEY_DELIMITER)) {
  throw new Error('CATEGORY_SEARCH_KEY_DELIMITER must be URL safe');
}
